import axios, { AxiosResponse } from "axios";
import { DataTable } from "graphql/_Types";
import { getEnvVar } from "ideas.env";
import { getRequestHeaders } from "utils/getRequestHeaders";

type CreateTestTableResponse = Pick<DataTable, "id" | "key">;
/**
 * Backend Endpoint to validate bundle structure and compatibility
 * @param file File
 * @param toolVersionId
 * @returns information about whether bundle is valid and compatible
 * with existing spec, and information about how the backend will resolve
 * incompatibilities
 */
export const createTestTable = async (
  toolVersionId: number,
): Promise<CreateTestTableResponse> => {
  const headers = await getRequestHeaders();

  const res = await axios.post<
    undefined,
    AxiosResponse<CreateTestTableResponse>
  >(
    getEnvVar("URL_TRS_TOOL_VERSION_GENERATE_TABLE")(toolVersionId),
    undefined,
    { headers },
  );

  return res.data;
};
